'use strict';

module.controller('TopNavBarCtrl', [ '$scope', '$state', 'securityService', 'alertService', '$interval', 'Auth', function($scope, $state, securityService, alertService, $interval, Auth) {
	
	
	$scope.accountURL = '';
	$scope.notifications = [];
	$scope.numNotificationsNotViewed = 0;
	
	$scope.logout = function() {
		securityService.logOut();
	};

	$scope.generadeUrlAccount = function() {
		$scope.accountURL = Auth.authz.authServerUrl + "/realms/" + Auth.authz.realm + "/account";
	};
	
	$scope.generadeUrlAccount();
	
	$scope.getUserCompleteName = function(){
		return Auth.authz.idTokenParsed.name;		
	};

} ]);